module.exports = __webpack_public_path__ + "img/signpost-fill.ed6fb6a3.svg";